export default "__VITE_ASSET__WLmEjeEA__";